// extracted by mini-css-extract-plugin
export default {"list":"AdQCHistory_list__6d5-E","title":"AdQCHistory_title__+G7AQ"};